<template>
  <div :class="{ topBox: true, noScroll: isScroll }">
    <div class="top">
      <div class="topTitle"></div>
      <ul>
        <li>
          <router-link to="/HomePage">首页</router-link>
        </li>
        <li>
          <router-link to="/GamePage">Game 2024</router-link>
        </li>
        <li>
          <router-link to="/PreviousPage">往届链接</router-link>
        </li>
        <li>
          <a @click="dialogIsShow" v-if="register_login_Show">注册/登录</a>
          <a @click="ajax_logout" v-else style="color: red;">退出登录</a>
        </li>
      </ul>
      <div class="title"></div>
      <div class="sTitle"></div>
      <div class="logo"></div>
    </div>
    <div>
      <router-view></router-view>
    </div>

    <div v-if="isShow">
      <div class="black"></div>
      <div class="dialog">
        <div class="dialog_title">登录</div>
        <div class="dialog_cha" @click="dialogIsntShow"></div>

        <div class="content">
          <input
            type="text"
            name="telephone"
            id="telephone"
            placeholder="请输入您的邮箱"
            v-model="login_email"
          />
          <div class="tips">
            <i> </i>
            <p>
              没有账号？立即
              <span style="color: #ff4141; cursor: pointer" @click="go_register">注册</span>
            </p>
          </div>
          <input
            type="password"
            name="password"
            id="password"
            v-model="password"
            placeholder="请输入您的密码"
          />
          <!-- <input type="code" name="code" id="code" placeholder="验证码" />
          <button
            class="getCode"
            @click="getCodeFn"
            v-html="codeHtml"
            :disabled="codeBtnISabled"
          ></button> -->
          <button class="loginBtn" @click="ajax_login">登录</button>
        </div>
      </div>
    </div>

    <div v-if="isShow_register">
      <div class="black_register"></div>
      <div class="dialog_register">
        <div class="dialog_title_register">注册</div>
        <div class="dialog_cha_register" @click="dialogIsntShow_register"></div>

        <div class="content_register">
          <input
            type="text"
            name="telephone"
            id="telephone_register"
            placeholder="请输入您的邮箱"
            v-model="email"
          />
          <div class="tips_register">
          </div>
          <input
            type="password"
            name="password"
            id="password_register"
            placeholder="请输入您的密码"
            v-model="password1"
          />
          <input
            type="password"
            name="password_enter"
            id="password_register_enter"
            placeholder="确认密码"
            v-model="password2"
          />
          <!-- <input type="code" name="code" id="code" placeholder="验证码" />
          <button
            class="getCode"
            @click="getCodeFn"
            v-html="codeHtml"
            :disabled="codeBtnISabled"
          ></button> -->
          <button class="loginBtn_register" @click="ajax_register">注册</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      screenHeight: 0,
      isScroll: false,
      isShow: false,
      codeHtml: '发送验证码',
      codeBtnISabled: false,
      isShow_register: false,
      password1: '',
      password2: '',
      email: '',
      login_email: '',
      password: '',
      sessionid: '',
      register_login_Show: true
    }
  },
  methods: {
    updateScreenHeight () {
      this.screenHeight = window.innerHeight
      // if (document.querySelector('.noScroll').style.height === undefined) return
      // document.querySelector('.noScroll').style.height =
      //   this.screenHeight - 1 + 'px'
    },
    dialogIsShow () {
      this.isShow = true
    },
    dialogIsntShow () {
      this.isShow = false
    },
    getCodeFn () {
      this.codeBtnISabled = true
      let i = 59
      this.codeHtml = '重新获取：60'
      const timer = setInterval(() => {
        this.codeHtml = `重新获取：${i--}`
        if (i === -1) {
          clearInterval(timer)
          this.codeBtnISabled = false
          this.codeHtml = '获取验证码'
        }
      }, 1000)
    },
    dialogIsntShow_register () {
      this.isShow_register = false
    },
    go_register () {
      this.isShow = false
      this.isShow_register = true
    },
    // 注册点击请求事件
    async ajax_register () {
      if (this.password1 !== this.password2) {
        return alert('两次输入密码不一致，请重新输入')
      }
      await axios({
        method: 'POST',
        url: '/trans_web/my_view/signup/',
        data: {
          email: this.email,
          password1: this.password1
        },
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        alert(res.data.message)
        location.reload()
      }).catch(err => {
        console.log(err)
      })
    },
    ajax_login () {
      axios({
        url: '/trans_web/my_view2/login/',
        method: 'POST',
        data: {
          email: this.login_email,
          password: this.password
        },
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        // console.log(res.data.message)
        alert(res.data.message)
        location.reload()
      }).catch(err => {
        console.log(err)
      })
    },
    ajax_logout () {
      axios.get('/trans_web/user_logout/').then(res => {
        alert(res.data.message)
        location.reload()
      }).catch(err => {
        console.log(err)
      })
    },
    // 获取sessionid
    getSessionId () {
    // 获取所有的cookie
      const cookies = document.cookie.split('; ')
      // 查找名为'sessionid'的cookie
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].split('=')
        if (cookie[0] === 'sessionid') {
          return cookie[1] // 返回session ID的值
        }
      }
      return null // 如果没有找到，返回null
    },
    ajax_apply () {
      axios.get('/trans_web/my_view2/application_list/').then(res => {
        // console.log(res.data.message)
        if (res.data.message === '请登录！') {
          this.register_login_Show = true
        } else {
          this.register_login_Show = false
        }
      }).catch(err => {
        console.log(err)
      })
    }
  },
  mounted () {
    // 添加事件监听来获取新的屏幕高度
    window.addEventListener('resize', this.updateScreenHeight)
    // 初始调用获取初始屏幕高度
    this.updateScreenHeight()
    // console.log(this.updateScreenHeight())
    this.ajax_apply()
  }
}
</script>

<style lang="less" scoped>
@font-face {
  font-family: "FZLTZCHK";
  src: url("/src/assets/font/FZLTCHJW.TTF") format("truetype"); /* 使用webpack的别名&#126;@指向src目录 */
  font-weight: normal;
  font-style: normal;
}
a {
  text-decoration: none;
}
.topBox {
  width: 100%;
  .top {
    position: relative;
    width: 100%;
    height: 7.29rem;
    background: url(/src/assets/img/topBg.png) no-repeat;
    background-size: 100% 100%;
    margin: 0 auto;
    min-width: var(--content-width);
    .topTitle {
      position: absolute;
      top: 0.32rem;
      left: 3rem;
      width: 2rem;
      height: 0.29rem;
      background: url(/src/assets/img/Transportation.png) no-repeat;
      background-size: contain;
    }
    ul {
      // height: 0.8rem;
      position: absolute;
      top: 0.2rem;
      // padding-top: 0.3rem;
      right: 2.84rem;
      display: flex;
      list-style: none;
      li {
        margin: 0.2rem 0.1rem;
        font-family: FZLTZCHK;
        cursor: pointer;
        font-size: 0.12rem;
        a {
          font-weight: normal;
          // color: #1d1d1d;
          // line-height: 0.2rem;
          padding: 0.04rem 0.1rem;
        }
      }
    }
  }
  // active类
  .myClassActive {
    // overflow: hidden;
    color: #5d4df6;
    background: linear-gradient(
      0deg,
      rgba(137, 247, 254, 0.6) 0%,
      rgba(102, 166, 255, 0.6) 100%
    );
    border-radius: 0.18rem;
    border: 0.02rem solid;
    border-image: linear-gradient(0deg, #4facfe, #00f2fe);
  }
  // 标题
  .title {
    position: relative;
    top: 3.1rem;
    left: 3rem;
    width: 6.92rem;
    height: 0.6rem;
    background: url(/src/assets/img/title.png) no-repeat;
    background-size: contain;
  }
  .sTitle {
    position: relative;
    top: 3.46rem;
    left: 3rem;
    width: 4.87rem;
    height: 0.33rem;
    background: url(/src/assets/img/sTitle.png) no-repeat;
    background-size: contain;
  }
  .logo {
    position: relative;
    top: 1.18rem;
    left: 9.95rem;
    height: 3.18rem;
    width: 3.13rem;
    background: url(/src/assets/img/logo.png) no-repeat;
    background-size: contain;
  }
}

// 弹框控制
.dialog {
  height: 65%;
  width: 40%;
  max-height: 8rem;
  background-color: #fff;
  z-index: 3;
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  // box-shadow: 0.06rem 0.06rem 0.06rem 0.06rem rgba(130, 195, 255, 0.55);
  border-radius: 0.1rem;
  .content {
    position: relative;
    height: 80%;
    width: 80%;
    // background-color: pink;
    margin: 0 auto;
  }
  .dialog_title {
    font-size: 0.3rem;
    font-family: FZLTZCHK;
    padding-top: 0.3rem;
    padding-left: 0.3rem;
  }

  #telephone {
    width: 3rem;
    height: 0.65rem;
    background-color: #fff;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    border: 0.01rem solid #dee7f5;
    border-radius: 0.09rem;
    font-family: FZLTZCHK;
    font-size: 0.21rem;
    color: #595959;
    padding: 0 0.3rem;
    margin-left: 50%;
    transform: translate(-50%, -30%);
  }
  #password {
    width: 3rem;
    height: 0.65rem;
    background-color: #fff;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    border: 0.01rem solid #dee7f5;
    border-radius: 0.09rem;
    font-family: FZLTZCHK;
    font-size: 0.21rem;
    color: #595959;
    padding: 0 0.3rem;
    margin-left: 50%;
    transform: translate(-50%, -60%);
  }
  .tips {
    i {
      position: absolute;
      top: 1.12rem;
      left: 14%;
      background: url(/src/assets/img/tips.png) no-repeat;
      background-size: 100% 100%;
      height: 0.15rem;
      width: 0.15rem;
    }
    p {
      position: absolute;
      top: 1.18rem;
      left: -10%;
      font-size: 0.12rem;
      margin-left: 1.47rem;
      margin-top: -0.07rem;
      color: #595959;
      font-family: FZLTZCHK;
    }
  }
  #code {
    position: absolute;
    top: 40%;
    left: 13%;
    width: 1.4rem;
    height: 0.65rem;
    background-color: #fff;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    border: 0.01rem solid #dee7f5;
    border-radius: 0.09rem;
    font-family: FZLTZCHK;
    font-size: 0.21rem;
    color: #595959;
    padding: 0 0.3rem;
  }
  .getCode {
    position: absolute;
    width: 1.46rem;
    height: 0.65rem;
    top: 40%;
    left: 57%;
    font-family: FZLTZCHK;
    font-size: 0.21rem;
    color: #fff;
    background-color: #74b9ff;
    border-radius: 0.08rem;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    border: 0;
    cursor: pointer;
  }
  .loginBtn {
    position: absolute;
    width: 3.6rem;
    height: 0.65rem;
    top: 65%;
    left: 13%;
    font-family: FZLTZCHK;
    font-size: 0.21rem;
    color: #fff;
    background-color: #74b9ff;
    border-radius: 0.08rem;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    border: 0;
    cursor: pointer;
  }
}
.black {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 2;
}
.dialog_cha {
  position: absolute;
  top: 0.33rem;
  right: 0.33rem;
  height: 0.23rem;
  width: 0.23rem;
  background: url(/src/assets/img/cancel.png) no-repeat;
  background-size: 100%;
  cursor: pointer;
}

// 禁止滚动
.noScroll {
  overflow-y: hidden;
}

// 注册弹框控制
.dialog_register {
  height: 65%;
  width: 40%;
  max-height: 8rem;
  background-color: #fff;
  z-index: 3;
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  // box-shadow: 0.06rem 0.06rem 0.06rem 0.06rem rgba(130, 195, 255, 0.55);
  border-radius: 0.1rem;
  .content_register {
    position: relative;
    height: 80%;
    width: 80%;
    // background-color: pink;
    margin: 0 auto;
  }
  .dialog_title_register {
    font-size: 0.3rem;
    font-family: FZLTZCHK;
    padding-top: 0.3rem;
    padding-left: 0.3rem;
  }

  #telephone_register {
    width: 3rem;
    height: 0.65rem;
    background-color: #fff;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    border: 0.01rem solid #dee7f5;
    border-radius: 0.09rem;
    font-family: FZLTZCHK;
    font-size: 0.21rem;
    color: #595959;
    padding: 0 0.3rem;
    margin-left: 50%;
    transform: translate(-50%, -30%);
  }
  #password_register {
    width: 3rem;
    height: 0.65rem;
    background-color: #fff;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    border: 0.01rem solid #dee7f5;
    border-radius: 0.09rem;
    font-family: FZLTZCHK;
    font-size: 0.21rem;
    color: #595959;
    padding: 0 0.3rem;
    margin-left: 50%;
    transform: translate(-50%, -100%);
  }
  #password_register_enter {
    width: 3rem;
    height: 0.65rem;
    background-color: #fff;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    border: 0.01rem solid #dee7f5;
    border-radius: 0.09rem;
    font-family: FZLTZCHK;
    font-size: 0.21rem;
    color: #595959;
    padding: 0 0.3rem;
    margin-left: 50%;
    transform: translate(-50%, -170%);
  }
  .tips_register {
    i {
      position: absolute;
      top: 32%;
      left: 14%;
      background: url(/src/assets/img/tips.png) no-repeat;
      background-size: 100% 100%;
      height: 0.15rem;
      width: 0.15rem;
    }
    p {
      position: absolute;
      top: 34%;
      left: -10%;
      font-size: 0.12rem;
      margin-left: 1.47rem;
      margin-top: -0.07rem;
      color: #595959;
      font-family: FZLTZCHK;
    }
  }
  .loginBtn_register {
    position: absolute;
    width: 3.6rem;
    height: 0.65rem;
    top: 84%;
    left: 13%;
    font-family: FZLTZCHK;
    font-size: 0.21rem;
    color: #fff;
    background-color: #74b9ff;
    border-radius: 0.08rem;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    border: 0;
    cursor: pointer;
  }
}
.black_register {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 2;
}
.dialog_cha_register {
  position: absolute;
  top: 0.33rem;
  right: 0.33rem;
  height: 0.23rem;
  width: 0.23rem;
  background: url(/src/assets/img/cancel.png) no-repeat;
  background-size: 100%;
  cursor: pointer;
}
</style>
